module.exports = __webpack_public_path__ + "img/self_publisher.da8c2173.svg";